import React from 'react';
import { SlideContainer } from './SlideContainer';
import slideTelaImg from '../assets/SlideTela2.jpg';
import { ISlidePropostaData } from '../interface';

export interface SlideTelaProps {
  data?: ISlidePropostaData;
  scale?: number;
}

const DEFAULT_TEXTO_TELA = `TELA INTERATIVA DE 75 POLEGADAS EM COMODATO.\n\nACESSO INCLUSO AOS APLICATIVOS DASHBOARD E GOVFÁCIL.`;
const DEFAULT_TEXTO_TELA_85 = `TELA INTERATIVA DE 85 POLEGADAS EM COMODATO.\n\nACESSO INCLUSO AOS APLICATIVOS DASHBOARD E GOVFÁCIL.`;

export const SlideTela: React.FC<SlideTelaProps> = ({ data, scale = 1 }) => {
  const padrao = data?.tipo_tela === 'tela85' ? DEFAULT_TEXTO_TELA_85 : DEFAULT_TEXTO_TELA;
  const textoExibicao = (data?.texto_dispositivo || data?.texto_dispositivo_padrao || padrao).toUpperCase();

  return (
    <SlideContainer 
      showFooterLogo={false} 
      showWaves={false} 
      noPadding={true}
      backgroundImage={slideTelaImg}
      scale={scale}
      data={data}
    >
      <div style={{ position: 'relative', width: '100%', height: '100%' }}>
        <div
          style={{
            position: 'absolute',
            top: '25%',
            left: '755px',
            width: '46%',
            color: '#0077b6',
            fontWeight: 900,
            fontSize: 38,
            lineHeight: 1.35,
            letterSpacing: 0.5,
            textTransform: 'uppercase',
            whiteSpace: 'pre-line',
          }}
        >
          {textoExibicao}
        </div>
      </div>
    </SlideContainer>
  );
};